import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #1F845A)",
      d: "M5.04 7.474H3.044c-.297 0-.388.182-.2.41l3.814 4.63c.185.225.486.221.67-.01l3.665-4.611c.183-.231.096-.419-.2-.419H8.76L7.133 1.467c-.076-.283-.208-.279-.29 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }